import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import UROLogo from '../atoms/UROLogo';

const NAV_LINKS = [['Models', '#models'], ['Pricing', '#pricing'], ['API', '#api'], ['Docs', '#api']];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);

  // Close mobile menu on route change / resize above breakpoint
  useEffect(() => {
    if (!mobileOpen) return;
    const onResize = () => { if (window.innerWidth > 768) setMobileOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [mobileOpen]);

  return (
    <>
      <header className={`nav-shell ${scrolled ? 'scrolled' : ''}`}>
        <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72 }}>
          <UROLogo />
          <nav className="landing-nav-links row gap-8" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
            {NAV_LINKS.map(([l, href]) => (
              <a key={l} href={href} style={{ color: 'var(--text-2)', textDecoration: 'none', fontSize: 14, fontWeight: 500, transition: 'color .15s' }}
                 onMouseEnter={e => e.currentTarget.style.color = '#fff'}
                 onMouseLeave={e => e.currentTarget.style.color = 'var(--text-2)'}>
                {l}
              </a>
            ))}
          </nav>
          <div className="landing-nav-ctas row gap-3">
            <Link className="btn btn-sm btn-ghost" to="/login">Sign in</Link>
            <Link className="btn btn-primary btn-sm" to="/register">Get started free</Link>
          </div>
          <button
            className="landing-hamburger"
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMobileOpen(o => !o)}
            style={{
              background: 'none', border: '1px solid var(--border)', cursor: 'pointer',
              color: '#fff', width: 40, height: 40, borderRadius: 10,
              alignItems: 'center', justifyContent: 'center', padding: 0,
            }}
          >
            {mobileOpen ? (
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M2 2l14 14M16 2L2 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect y="3" width="18" height="2" rx="1" fill="currentColor"/>
                <rect y="8" width="18" height="2" rx="1" fill="currentColor"/>
                <rect y="13" width="18" height="2" rx="1" fill="currentColor"/>
              </svg>
            )}
          </button>
        </div>
      </header>

      {/* Mobile overlay menu */}
      {mobileOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 200,
          background: 'rgba(5,5,5,.97)', backdropFilter: 'blur(16px)',
          display: 'flex', flexDirection: 'column',
          padding: '88px 32px 40px',
        }}>
          <nav style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {NAV_LINKS.map(([l, href]) => (
              <a
                key={l} href={href}
                onClick={() => setMobileOpen(false)}
                style={{ color: 'var(--text-2)', textDecoration: 'none', fontSize: 24, fontWeight: 600, padding: '12px 0', borderBottom: '1px solid var(--border)' }}
              >
                {l}
              </a>
            ))}
          </nav>
          <div style={{ marginTop: 40, display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Link className="btn btn-ghost btn-lg" to="/login" onClick={() => setMobileOpen(false)} style={{ justifyContent: 'center' }}>Sign in</Link>
            <Link className="btn btn-primary btn-lg" to="/register" onClick={() => setMobileOpen(false)} style={{ justifyContent: 'center' }}>Get started free</Link>
          </div>
        </div>
      )}
    </>
  );
}
